<div
  *transloco="let t; read: 'calculator_result.result.values.solar-assessment'"
  class="flex flex-col font-bold">
  <psc-section-title
    class="mb-2"
    [title]="t('title')"
    alignment="left"
    [color]="colorConfig.textColor"
    [lineColor]="colorConfig.bgColor"
    [size]="smallTitle ? 'small' : 'normal'"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>

  <!--   t(effectiveness.title, effectiveness.info, system-capacity.title, system-capacity.info, solar-area.title, solar-area.info) -->
  <psc-value-text
    *ngFor="let assessmentValue of solarAssessmentValues; let even = even"
    [coloredRow]="even"
    [coloredRowColor]="colorConfig.bgColor"
    [primaryTextColor]="colorConfig.textColor"
    [secondaryTextColor]="colorConfig.textColor"
    [label]="t(assessmentValue.labelKey + '.title')"
    [value]="assessmentValue.value"
    [numberOfDecimals]="assessmentValue.numberOfDecimals"
    [unit]="assessmentValue.unit"
    [infoText]="t(assessmentValue.labelKey + '.info')"
  ></psc-value-text>
</div>
